/* Total Eyewear — prescription tint-colour gate (defence-in-depth, 2026-07-05).
   The section (sections/prescription-addon.liquid) already blocks Add-to-bag
   when a sun tint is chosen without a colour (validateAndBuild). This standalone
   guard adds a PROACTIVE block: it also stops the customer leaving the Extras
   step, and disables the Add-to-bag button, until a tint colour is picked —
   showing an inline "Please choose a tint colour" prompt. Works purely off the
   wizard's DOM state, so it needs no access to the section's internals. */
(function () {
  function initSection(root) {
    if (!root || root.__rxTintGuard) return;
    root.__rxTintGuard = true;

    var tintColourBlock = root.querySelector('[data-rxw-tintcolour]');

    function activeStyle() {
      var b = root.querySelector('[data-tintstyle].is-active');
      return b ? (b.getAttribute('data-tintstyle') || '') : '';
    }
    function colourChosen() {
      if (root.querySelector('[data-tintcolour].is-active')) return true;
      var sel = root.querySelector('[data-rx-tintcolour]');
      return !!(sel && sel.value);
    }
    /* A colour is required only when a real sun tint (solid/gradient) is active. */
    function needsColour() {
      return activeStyle() !== '' && !colourChosen();
    }

    function showPrompt(show) {
      if (!tintColourBlock) return;
      var msg = tintColourBlock.querySelector('.rx-error.rxtg-msg');
      if (show) {
        if (!msg) {
          msg = document.createElement('div');
          msg.className = 'rx-error is-visible rxtg-msg';
          msg.setAttribute('role', 'alert');
          msg.style.marginTop = '10px';
          msg.textContent = 'Please choose a tint colour before continuing — or select “No tint” above.';
          tintColourBlock.appendChild(msg);
        } else {
          msg.classList.add('is-visible');
        }
      } else if (msg) {
        msg.classList.remove('is-visible');
      }
    }

    function sync() {
      var need = needsColour();
      var atb = root.querySelector('[data-rxw-addtobag]');
      if (atb) {
        atb.setAttribute('aria-disabled', need ? 'true' : 'false');
        atb.classList.toggle('rxtg-blocked', need);
        atb.style.opacity = need ? '0.55' : '';
        atb.style.cursor = need ? 'not-allowed' : '';
      }
      if (!need) showPrompt(false);
    }

    /* Capture-phase block: runs before the wizard's own click handlers, so it
       can stop the Extras-step "Continue" and the "Add to bag" button when a
       tint colour is still missing. Only blocks in the invalid state. */
    root.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest
        ? ev.target.closest('[data-step-next],[data-rxw-addtobag]')
        : null;
      if (!t) return;
      if (t.hasAttribute('data-step-next')) {
        var step = t.closest('[data-rx-step]');
        if (!step || step.getAttribute('data-rx-step') !== '4') return; /* only gate step 4 */
      }
      if (needsColour()) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        showPrompt(true);
        if (tintColourBlock) tintColourBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);

    /* Keep the button/prompt state fresh as the customer clicks around. */
    root.addEventListener('click', function () { setTimeout(sync, 0); });
    sync();
  }

  function boot() {
    var nodes = document.querySelectorAll('.prescription-addon');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
